import type { IProject } from '@shared/types';

// Проект связан с конкретным контрактом; работы других подрядчиков поставщику не приписываем.
export const PROJECTS: readonly IProject[] = [
  {
    id: 'kozmodyemyanovka',
    title: 'Спортивная площадка у сельской школы',
    location: 'Большая Козьмодемьяновка',
    region: 'Курская область',
    year: 2026,
    contractId: '3462290215326000006',
    role: 'Поставка и установка оборудования',
    description:
      'Поставили и установили силовые тренажёры, турники и брусья рядом со школой на улице Молодёжной. На площадке жители могут тренироваться самостоятельно и готовиться к сдаче нормативов.',
    equipment: ['Силовые тренажёры', 'Турники и брусья', 'Снаряды для нормативов'],
    photos: [
      {
        src: '/projects/kozmodyemyanovka-01.webp',
        thumbnail: '/projects/kozmodyemyanovka-01-640.webp',
        width: 1280,
        height: 853,
        alt: 'Занятия на площадке в Большой Козьмодемьяновке: скамья для наклонов, силовые тренажёры и школьное здание',
      },
    ],
    photoCredit: 'Ольга Танкова / «Единая Россия», Курская область',
    photoSourceUrl:
      'https://kursk.er.ru/activity/news/aleksej-zolotarev-my-otkryvaem-territoriyu-sily-voli-i-novyh-dostizhenij',
    sources: [
      {
        label: 'Публикация об открытии и участии ИП Ветюгова',
        url: 'https://proekty.er.ru/news/er-news-3642638',
      },
      {
        label: 'Расположение и оборудование площадки',
        url: 'https://pg46.ru/sports/31794',
      },
    ],
  },
  {
    id: 'suzemka',
    title: 'Спортивная площадка у ФОК «Прометей»',
    location: 'Суземка',
    region: 'Брянская область',
    year: 2026,
    contractId: '3322800158226000009',
    role: 'Оснащение площадки и укладка покрытия',
    description:
      'Оснастили площадку рядом с ФОК «Прометей» тренажёрами и гимнастическими снарядами, уложили амортизирующее покрытие. В числе первых здесь прошли тестирование работники культуры района.',
    equipment: ['Уличные тренажёры', 'Гимнастические снаряды', 'Амортизирующее покрытие'],
    photos: [
      {
        src: '/projects/suzemka-01.webp',
        thumbnail: '/projects/suzemka-01-640.webp',
        width: 1351,
        height: 1040,
        alt: 'Участницы на площадке у ФОК «Прометей» в Суземке, сектор прыжков в длину и турники',
      },
      {
        src: '/projects/suzemka-02.webp',
        thumbnail: '/projects/suzemka-02-640.webp',
        width: 1285,
        height: 1003,
        alt: 'Участники на площадке в Суземке: гимнастические снаряды и зелёное покрытие',
      },
      {
        src: '/projects/suzemka-03.webp',
        thumbnail: '/projects/suzemka-03-640.webp',
        width: 1440,
        height: 1920,
        alt: 'Занятие на уличном эллиптическом тренажёре на новой спортивной площадке в Суземке',
      },
    ],
    photoCredit: 'Газета «Рассвет»',
    photoSourceUrl:
      'https://gazeta-suzemka.ru/sport/2026/10/12/v-suzemke-otkryli-novuyu-ploshhadku-dlya-sdachi-normativov-gto/',
    sources: [
      {
        label: 'Работы ИП Александра Ветюгова на объекте',
        url: 'https://bug32.ru/2026/09/05/v-suzemke-zavershaetsya-stroitelstvo-sovremennoj-ploshhadki-gto/',
      },
      {
        label: 'Открытие готовой площадки',
        url: 'https://riastrela.ru/p/233654/',
      },
    ],
  },
  {
    id: 'besedino',
    title: 'Площадка для нормативов в Бесединской школе',
    location: 'Беседино',
    region: 'Курская область',
    year: 2026,
    contractId: '3461100805726000011',
    role: 'Поставка спортивного оборудования',
    description:
      'Поставили перекладины, рукоход и гимнастические снаряды для площадки Бесединской школы. На открытии ученики опробовали оборудование для подготовки к нормативам.',
    equipment: ['Гимнастические снаряды', 'Перекладины', 'Рукоход'],
    photos: [
      {
        src: '/projects/besedino-01.webp',
        thumbnail: '/projects/besedino-01-640.webp',
        width: 1280,
        height: 960,
        alt: 'Ученик на рукоходе во время открытия площадки Бесединской школы, рядом гимнастические кольца и перекладины',
      },
    ],
    photoCredit: 'Газета «Сельская новь»',
    photoSourceUrl:
      'http://xn----7sbhjzfriuc4jh8a.xn--p1ai/novosti-rayona/13750-v-besedino-otkryli-ploshchadku-gto',
    sources: [
      {
        label: 'Репортаж об открытии школьной площадки',
        url: 'http://xn----7sbhjzfriuc4jh8a.xn--p1ai/novosti-rayona/13750-v-besedino-otkryli-ploshchadku-gto',
      },
    ],
  },
  {
    id: 'makaryev',
    title: '«Умная» спортивная площадка в Макарьеве',
    location: 'Макарьев',
    region: 'Костромская область',
    year: 2025,
    contractId: '3441600125925000001',
    role: 'Поставка и монтаж комплекта оборудования и покрытия',
    description:
      'Поставили и смонтировали воркаут-комплекс, силовые тренажёры, сборные трибуны и покрытие на улице Окружной. На оборудовании размещены QR-коды с инструкциями к упражнениям.',
    equipment: ['Воркаут', 'Силовые тренажёры', 'Трибуны', 'Резиновое покрытие'],
    photos: [
      {
        src: '/projects/makaryev-01.webp',
        thumbnail: '/projects/makaryev-01-640.webp',
        width: 1242,
        height: 790,
        alt: 'Воркаут-комплекс с турниками, гимнастическими скамьями и кольцами на площадке в Макарьеве',
      },
      {
        src: '/projects/makaryev-02.webp',
        thumbnail: '/projects/makaryev-02-640.webp',
        width: 1079,
        height: 620,
        alt: 'Игровое поле с красным покрытием и ограждением на спортивной площадке в Макарьеве',
      },
      {
        src: '/projects/makaryev-03.webp',
        thumbnail: '/projects/makaryev-03-640.webp',
        width: 1280,
        height: 960,
        alt: 'Силовые уличные тренажёры с дисками и QR-кодами на площадке в Макарьеве',
      },
    ],
    photoCredit: 'Администрация Костромской области / K1NEWS',
    photoSourceUrl:
      'https://k1news.ru/news/sports/umnuyu-sportploschadku-za-9-millionov-otkryli-pod-kostromoy/',
    sources: [
      {
        label: 'Репортаж о готовой площадке',
        url: 'https://k1news.ru/news/sports/umnuyu-sportploschadku-za-9-millionov-otkryli-pod-kostromoy/',
      },
    ],
  },
  {
    id: 'ostrogozhsk',
    title: 'Площадка у спорткомплекса «Северная арена»',
    location: 'Острогожск',
    region: 'Воронежская область',
    year: 2025,
    contractId: '3361900651825000001',
    role: 'Поставка и монтаж спортивного оборудования',
    description:
      'Поставили и смонтировали тренажёры, гимнастические скамьи, перекладины и снаряды для прыжков и упражнений с гирей на улице Карла Маркса, 77. Основание и благоустройство выполнялись отдельным этапом.',
    equipment: ['Уличные тренажёры', 'Гимнастические скамьи', 'Снаряды для нормативов'],
    photos: [
      {
        src: '/projects/ostrogozhsk-01.webp',
        thumbnail: '/projects/ostrogozhsk-01-640.webp',
        width: 930,
        height: 523,
        alt: 'Занятие на гимнастических кольцах новой площадки в Острогожске',
      },
      {
        src: '/projects/ostrogozhsk-02.webp',
        thumbnail: '/projects/ostrogozhsk-02-640.webp',
        width: 1200,
        height: 675,
        alt: 'Участники опробуют перекладины на площадке у «Северной арены» в Острогожске',
      },
    ],
    photoCredit: 'Александр Юрковский / РИА «Воронеж»',
    photoSourceUrl:
      'https://riavrn.ru/news/v-ostrogozhske-otkrylas-sportploshadka-dlya-sdachi-normativov-gto/',
    sources: [
      {
        label: 'Открытие и состав оборудования',
        url: 'https://riavrn.ru/news/v-ostrogozhske-otkrylas-sportploshadka-dlya-sdachi-normativov-gto/',
      },
    ],
  },
  {
    id: 'susanino',
    title: 'Спортивная площадка Сусанинской школы',
    location: 'Сусанино',
    region: 'Костромская область',
    year: 2025,
    contractId: '3442800222525000006',
    role: 'Поставка и монтаж оборудования',
    description:
      'Поставили и смонтировали оборудование для подготовки к нормативам во дворе Сусанинской школы. Ученики занимаются здесь на уроках физкультуры и после занятий, вечером — взрослые жители посёлка.',
    equipment: ['Силовые тренажёры', 'Гимнастические скамьи', 'Снаряды для нормативов'],
    photos: [
      {
        src: '/projects/susanino-01.webp',
        thumbnail: '/projects/susanino-01-640.webp',
        width: 800,
        height: 600,
        alt: 'Школьники занимаются на синем уличном тренажёре на площадке Сусанинской школы',
      },
      {
        src: '/projects/susanino-02.webp',
        thumbnail: '/projects/susanino-02-640.webp',
        width: 800,
        height: 600,
        alt: 'Школьница выполняет прыжок в длину с места на красном покрытии спортивной площадки в Сусанине',
      },
    ],
    photoCredit: 'Официальный канал Сергея Ситникова',
    photoSourceUrl: 'https://t.me/sk_sitnikov/14883',
    sources: [
      {
        label: 'Открытие площадки ГТО в Сусанинской школе',
        url: 'https://kostroma.mk.ru/social/2025/09/23/v-susaninskoy-shkole-otkryli-novuyu-sportploshhadku.html',
      },
      {
        label: 'Площадка в перечне администрации округа',
        url: 'https://susanino.kostroma.gov.ru/sotsialnaya-sfera/karta-obektov-zdorovogo-obraza-zhizni/',
      },
    ],
  },
];
